//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://shop-dev.geospatial.com";

    }

    get(gid: string , cancelToken?: CancelToken | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/api/Product/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Product> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Product.fromJS(resultData200);
            return Promise.resolve<Product>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product>(null as any);
    }

    getByPermId(b32: string | null , cancelToken?: CancelToken | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/api/Product/{b32}";
        if (b32 === undefined || b32 === null)
            throw new Error("The parameter 'b32' must be defined.");
        url_ = url_.replace("{b32}", encodeURIComponent("" + b32));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByPermId(_response);
        });
    }

    protected processGetByPermId(response: AxiosResponse): Promise<Product> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Product.fromJS(resultData200);
            return Promise.resolve<Product>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product>(null as any);
    }

    getBySku(sku: string | null , cancelToken?: CancelToken | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/api/Product/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySku(_response);
        });
    }

    protected processGetBySku(response: AxiosResponse): Promise<Product> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Product.fromJS(resultData200);
            return Promise.resolve<Product>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product>(null as any);
    }

    getSnipCartInfo(sku: string | null , cancelToken?: CancelToken | undefined): Promise<ProductInfo> {
        let url_ = this.baseUrl + "/api/Product/snipcart/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSnipCartInfo(_response);
        });
    }

    protected processGetSnipCartInfo(response: AxiosResponse): Promise<ProductInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductInfo.fromJS(resultData200);
            return Promise.resolve<ProductInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductInfo>(null as any);
    }
}

export class PublicationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://shop-dev.geospatial.com";

    }

    get(gid: string , cancelToken?: CancelToken | undefined): Promise<Publication> {
        let url_ = this.baseUrl + "/api/Publication/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Publication> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Publication.fromJS(resultData200);
            return Promise.resolve<Publication>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Publication>(null as any);
    }

    getByPermId(b32: string | null , cancelToken?: CancelToken | undefined): Promise<Publication> {
        let url_ = this.baseUrl + "/api/Publication/{b32}";
        if (b32 === undefined || b32 === null)
            throw new Error("The parameter 'b32' must be defined.");
        url_ = url_.replace("{b32}", encodeURIComponent("" + b32));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByPermId(_response);
        });
    }

    protected processGetByPermId(response: AxiosResponse): Promise<Publication> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Publication.fromJS(resultData200);
            return Promise.resolve<Publication>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Publication>(null as any);
    }

    getByHandle(handle: string | null , cancelToken?: CancelToken | undefined): Promise<Publication> {
        let url_ = this.baseUrl + "/api/Publication/{handle}";
        if (handle === undefined || handle === null)
            throw new Error("The parameter 'handle' must be defined.");
        url_ = url_.replace("{handle}", encodeURIComponent("" + handle));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByHandle(_response);
        });
    }

    protected processGetByHandle(response: AxiosResponse): Promise<Publication> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Publication.fromJS(resultData200);
            return Promise.resolve<Publication>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Publication>(null as any);
    }

    getProductVectorTile(gid: string, lvl: number, col: number, row: number , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Publication/{gid}/tile/{lvl}/{col}/{row}.mvt";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        if (lvl === undefined || lvl === null)
            throw new Error("The parameter 'lvl' must be defined.");
        url_ = url_.replace("{lvl}", encodeURIComponent("" + lvl));
        if (col === undefined || col === null)
            throw new Error("The parameter 'col' must be defined.");
        url_ = url_.replace("{col}", encodeURIComponent("" + col));
        if (row === undefined || row === null)
            throw new Error("The parameter 'row' must be defined.");
        url_ = url_.replace("{row}", encodeURIComponent("" + row));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductVectorTile(_response);
        });
    }

    protected processGetProductVectorTile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getProductVectorTileManifest(gid: string , cancelToken?: CancelToken | undefined): Promise<TileJSONManifest> {
        let url_ = this.baseUrl + "/api/Publication/{gid}/tile/manifest.json";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductVectorTileManifest(_response);
        });
    }

    protected processGetProductVectorTileManifest(response: AxiosResponse): Promise<TileJSONManifest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TileJSONManifest.fromJS(resultData200);
            return Promise.resolve<TileJSONManifest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TileJSONManifest>(null as any);
    }
}

export class PublisherClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://shop-dev.geospatial.com";

    }

    get(gid: string , cancelToken?: CancelToken | undefined): Promise<Publisher> {
        let url_ = this.baseUrl + "/api/Publisher/{gid}";
        if (gid === undefined || gid === null)
            throw new Error("The parameter 'gid' must be defined.");
        url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Publisher> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Publisher.fromJS(resultData200);
            return Promise.resolve<Publisher>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Publisher>(null as any);
    }

    getByPermId(b32: string | null , cancelToken?: CancelToken | undefined): Promise<Publisher> {
        let url_ = this.baseUrl + "/api/Publisher/{b32}";
        if (b32 === undefined || b32 === null)
            throw new Error("The parameter 'b32' must be defined.");
        url_ = url_.replace("{b32}", encodeURIComponent("" + b32));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByPermId(_response);
        });
    }

    protected processGetByPermId(response: AxiosResponse): Promise<Publisher> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Publisher.fromJS(resultData200);
            return Promise.resolve<Publisher>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Publisher>(null as any);
    }
}

export class RequestInfoClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://shop-dev.geospatial.com";

    }

    get(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/RequestInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            withCredentials: true,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    post(contact_Surname: string | null | undefined, contact_GivenName: string | null | undefined, contact_Country: string | null | undefined, contact_Salutation: string | null | undefined, contact_Company: string | null | undefined, contact_Position: string | null | undefined, contact_Email: string | null | undefined, contact_Phone: string | null | undefined, contact_DisplayName: string | null | undefined, inquiry: string | null | undefined, sKUs: string[] | null | undefined, products: Product[] | null | undefined, publications: Publication[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/RequestInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contact_Surname !== null && contact_Surname !== undefined)
            content_.append("Contact.Surname", contact_Surname.toString());
        if (contact_GivenName !== null && contact_GivenName !== undefined)
            content_.append("Contact.GivenName", contact_GivenName.toString());
        if (contact_Country !== null && contact_Country !== undefined)
            content_.append("Contact.Country", contact_Country.toString());
        if (contact_Salutation !== null && contact_Salutation !== undefined)
            content_.append("Contact.Salutation", contact_Salutation.toString());
        if (contact_Company !== null && contact_Company !== undefined)
            content_.append("Contact.Company", contact_Company.toString());
        if (contact_Position !== null && contact_Position !== undefined)
            content_.append("Contact.Position", contact_Position.toString());
        if (contact_Email !== null && contact_Email !== undefined)
            content_.append("Contact.Email", contact_Email.toString());
        if (contact_Phone !== null && contact_Phone !== undefined)
            content_.append("Contact.Phone", contact_Phone.toString());
        if (contact_DisplayName !== null && contact_DisplayName !== undefined)
            content_.append("Contact.DisplayName", contact_DisplayName.toString());
        if (inquiry !== null && inquiry !== undefined)
            content_.append("Inquiry", inquiry.toString());
        if (sKUs !== null && sKUs !== undefined)
            sKUs.forEach(item_ => content_.append("SKUs", item_.toString()));
        if (products !== null && products !== undefined)
            products.forEach(item_ => content_.append("Products", item_.toString()));
        if (publications !== null && publications !== undefined)
            publications.forEach(item_ => content_.append("Publications", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            withCredentials: true,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SearchClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://shop-dev.geospatial.com";

    }

    getTypes(  cancelToken?: CancelToken | undefined): Promise<PublicationType[]> {
        let url_ = this.baseUrl + "/api/Search/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTypes(_response);
        });
    }

    protected processGetTypes(response: AxiosResponse): Promise<PublicationType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicationType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicationType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationType[]>(null as any);
    }

    getPublishers(  cancelToken?: CancelToken | undefined): Promise<Publisher[]> {
        let url_ = this.baseUrl + "/api/Search/publishers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublishers(_response);
        });
    }

    protected processGetPublishers(response: AxiosResponse): Promise<Publisher[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Publisher.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Publisher[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Publisher[]>(null as any);
    }

    getLanguages(  cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Search/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getCountries(  cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Search/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    countAggregated(filters: Filters , cancelToken?: CancelToken | undefined): Promise<MatchCounts> {
        let url_ = this.baseUrl + "/api/Search/count/aggregated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountAggregated(_response);
        });
    }

    protected processCountAggregated(response: AxiosResponse): Promise<MatchCounts> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MatchCounts.fromJS(resultData200);
            return Promise.resolve<MatchCounts>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MatchCounts>(null as any);
    }

    countProducts(publication: string | null, filters: Filters , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Search/count/{publication}";
        if (publication === undefined || publication === null)
            throw new Error("The parameter 'publication' must be defined.");
        url_ = url_.replace("{publication}", encodeURIComponent("" + publication));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountProducts(_response);
        });
    }

    protected processCountProducts(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    findAggregated(sort: string | null | undefined, dir: string | null | undefined, limit: number | undefined, offset: number | undefined, filters: Filters , cancelToken?: CancelToken | undefined): Promise<PublicationMatch[]> {
        let url_ = this.baseUrl + "/api/Search?";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (dir !== undefined && dir !== null)
            url_ += "dir=" + encodeURIComponent("" + dir) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindAggregated(_response);
        });
    }

    protected processFindAggregated(response: AxiosResponse): Promise<PublicationMatch[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicationMatch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicationMatch[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationMatch[]>(null as any);
    }

    get(searchTerm: string | null | undefined, limit: number | undefined , cancelToken?: CancelToken | undefined): Promise<ScoredSearchResultOfPublication[]> {
        let url_ = this.baseUrl + "/api/Search?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ScoredSearchResultOfPublication[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScoredSearchResultOfPublication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScoredSearchResultOfPublication[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScoredSearchResultOfPublication[]>(null as any);
    }

    findProducts(publication: string | null, sort: string | null | undefined, dir: string | null | undefined, limit: number | undefined, offset: number | undefined, filters: PublicationSubFilters , cancelToken?: CancelToken | undefined): Promise<Product[]> {
        let url_ = this.baseUrl + "/api/Search/publication/{publication}?";
        if (publication === undefined || publication === null)
            throw new Error("The parameter 'publication' must be defined.");
        url_ = url_.replace("{publication}", encodeURIComponent("" + publication));
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (dir !== undefined && dir !== null)
            url_ += "dir=" + encodeURIComponent("" + dir) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindProducts(_response);
        });
    }

    protected processFindProducts(response: AxiosResponse): Promise<Product[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Product[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product[]>(null as any);
    }

    getProductsForPublication(publication: string, sort: string | null | undefined, dir: string | null | undefined, limit: number | undefined, offset: number | undefined , cancelToken?: CancelToken | undefined): Promise<Product[]> {
        let url_ = this.baseUrl + "/api/Search/publication/{publication}?";
        if (publication === undefined || publication === null)
            throw new Error("The parameter 'publication' must be defined.");
        url_ = url_.replace("{publication}", encodeURIComponent("" + publication));
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (dir !== undefined && dir !== null)
            url_ += "dir=" + encodeURIComponent("" + dir) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsForPublication(_response);
        });
    }

    protected processGetProductsForPublication(response: AxiosResponse): Promise<Product[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Product.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Product[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product[]>(null as any);
    }

    geocode(query: string | null | undefined, limit: number | undefined , cancelToken?: CancelToken | undefined): Promise<Location[]> {
        let url_ = this.baseUrl + "/api/Search/geocode?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeocode(_response);
        });
    }

    protected processGeocode(response: AxiosResponse): Promise<Location[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Location.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Location[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Location[]>(null as any);
    }
}

export class Product implements IProduct {
    gid!: string;
    publicationGid!: string;
    publisherGid!: string;
    typeid!: number;
    typeLabel?: string | undefined;
    subtypeLabel?: string | undefined;
    permId?: string | undefined;
    sku!: string;
    slug?: string | undefined;
    title?: string | undefined;
    mapIndex?: string | undefined;
    country?: string | undefined;
    scaleName?: string | undefined;
    publishedDate?: number | undefined;
    languages?: string[] | undefined;
    countries?: string[] | undefined;
    bounds?: number[] | undefined;
    inventory?: string | undefined;
    exposure?: number | undefined;
    sales?: number | undefined;
    printPrice?: number | undefined;
    imagePrice?: number | undefined;
    dataPrice?: number | undefined;
    stockPrice?: number | undefined;
    thumbnail?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.publicationGid = _data["publicationGid"];
            this.publisherGid = _data["publisherGid"];
            this.typeid = _data["typeid"];
            this.typeLabel = _data["typeLabel"];
            this.subtypeLabel = _data["subtypeLabel"];
            this.permId = _data["permId"];
            this.sku = _data["sku"];
            this.slug = _data["slug"];
            this.title = _data["title"];
            this.mapIndex = _data["mapIndex"];
            this.country = _data["country"];
            this.scaleName = _data["scaleName"];
            this.publishedDate = _data["publishedDate"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            if (Array.isArray(_data["bounds"])) {
                this.bounds = [] as any;
                for (let item of _data["bounds"])
                    this.bounds!.push(item);
            }
            this.inventory = _data["inventory"];
            this.exposure = _data["exposure"];
            this.sales = _data["sales"];
            this.printPrice = _data["printPrice"];
            this.imagePrice = _data["imagePrice"];
            this.dataPrice = _data["dataPrice"];
            this.stockPrice = _data["stockPrice"];
            this.thumbnail = _data["thumbnail"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["publicationGid"] = this.publicationGid;
        data["publisherGid"] = this.publisherGid;
        data["typeid"] = this.typeid;
        data["typeLabel"] = this.typeLabel;
        data["subtypeLabel"] = this.subtypeLabel;
        data["permId"] = this.permId;
        data["sku"] = this.sku;
        data["slug"] = this.slug;
        data["title"] = this.title;
        data["mapIndex"] = this.mapIndex;
        data["country"] = this.country;
        data["scaleName"] = this.scaleName;
        data["publishedDate"] = this.publishedDate;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        if (Array.isArray(this.bounds)) {
            data["bounds"] = [];
            for (let item of this.bounds)
                data["bounds"].push(item);
        }
        data["inventory"] = this.inventory;
        data["exposure"] = this.exposure;
        data["sales"] = this.sales;
        data["printPrice"] = this.printPrice;
        data["imagePrice"] = this.imagePrice;
        data["dataPrice"] = this.dataPrice;
        data["stockPrice"] = this.stockPrice;
        data["thumbnail"] = this.thumbnail;
        return data;
    }
}

export interface IProduct {
    gid: string;
    publicationGid: string;
    publisherGid: string;
    typeid: number;
    typeLabel?: string | undefined;
    subtypeLabel?: string | undefined;
    permId?: string | undefined;
    sku: string;
    slug?: string | undefined;
    title?: string | undefined;
    mapIndex?: string | undefined;
    country?: string | undefined;
    scaleName?: string | undefined;
    publishedDate?: number | undefined;
    languages?: string[] | undefined;
    countries?: string[] | undefined;
    bounds?: number[] | undefined;
    inventory?: string | undefined;
    exposure?: number | undefined;
    sales?: number | undefined;
    printPrice?: number | undefined;
    imagePrice?: number | undefined;
    dataPrice?: number | undefined;
    stockPrice?: number | undefined;
    thumbnail?: string | undefined;
}

export class ProductInfo implements IProductInfo {
    name!: string;
    id!: string;
    price!: number;
    url!: string;
    shippable!: boolean;
    description?: string | undefined;
    imageUrl?: string | undefined;
    categories?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
    customFields?: CustomField[] | undefined;

    constructor(data?: IProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.customFields) {
                this.customFields = [];
                for (let i = 0; i < data.customFields.length; i++) {
                    let item = data.customFields[i];
                    this.customFields[i] = item && !(<any>item).toJSON ? new CustomField(item) : <CustomField>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.price = _data["price"];
            this.url = _data["url"];
            this.shippable = _data["shippable"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.categories = _data["categories"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["price"] = this.price;
        data["url"] = this.url;
        data["shippable"] = this.shippable;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["categories"] = this.categories;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductInfo {
    name: string;
    id: string;
    price: number;
    url: string;
    shippable: boolean;
    description?: string | undefined;
    imageUrl?: string | undefined;
    categories?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
    customFields?: ICustomField[] | undefined;
}

export class CustomField implements ICustomField {
    name!: string;
    value?: string | undefined;
    type?: string | undefined;
    optionSummary?: string | undefined;

    constructor(data?: ICustomField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.optionSummary = _data["optionSummary"];
        }
    }

    static fromJS(data: any): CustomField {
        data = typeof data === 'object' ? data : {};
        let result = new CustomField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        data["optionSummary"] = this.optionSummary;
        return data;
    }
}

export interface ICustomField {
    name: string;
    value?: string | undefined;
    type?: string | undefined;
    optionSummary?: string | undefined;
}

export class Publication implements IPublication {
    gid!: string;
    publisherGid!: string;
    permId?: string | undefined;
    name?: string | undefined;
    slug?: string | undefined;
    sku!: string;
    publisherName?: string | undefined;
    typeid!: number;
    typeLabel?: string | undefined;
    subtypeLabel?: string | undefined;
    description?: string | undefined;
    covcountry?: string | undefined;
    scaleValue?: number;
    scaleName?: string | undefined;
    itemCount!: number;
    years?: IntervalOfUInt16 | undefined;
    bounds?: number[] | undefined;
    languages?: string[] | undefined;
    thumbnail?: string | undefined;

    constructor(data?: IPublication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.years = data.years && !(<any>data.years).toJSON ? new IntervalOfUInt16(data.years) : <IntervalOfUInt16>this.years;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.publisherGid = _data["publisherGid"];
            this.permId = _data["permId"];
            this.name = _data["name"];
            this.slug = _data["slug"];
            this.sku = _data["sku"];
            this.publisherName = _data["publisherName"];
            this.typeid = _data["typeid"];
            this.typeLabel = _data["typeLabel"];
            this.subtypeLabel = _data["subtypeLabel"];
            this.description = _data["description"];
            this.covcountry = _data["covcountry"];
            this.scaleValue = _data["scaleValue"];
            this.scaleName = _data["scaleName"];
            this.itemCount = _data["itemCount"];
            this.years = _data["years"] ? IntervalOfUInt16.fromJS(_data["years"]) : <any>undefined;
            if (Array.isArray(_data["bounds"])) {
                this.bounds = [] as any;
                for (let item of _data["bounds"])
                    this.bounds!.push(item);
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.thumbnail = _data["thumbnail"];
        }
    }

    static fromJS(data: any): Publication {
        data = typeof data === 'object' ? data : {};
        let result = new Publication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["publisherGid"] = this.publisherGid;
        data["permId"] = this.permId;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["sku"] = this.sku;
        data["publisherName"] = this.publisherName;
        data["typeid"] = this.typeid;
        data["typeLabel"] = this.typeLabel;
        data["subtypeLabel"] = this.subtypeLabel;
        data["description"] = this.description;
        data["covcountry"] = this.covcountry;
        data["scaleValue"] = this.scaleValue;
        data["scaleName"] = this.scaleName;
        data["itemCount"] = this.itemCount;
        data["years"] = this.years ? this.years.toJSON() : <any>undefined;
        if (Array.isArray(this.bounds)) {
            data["bounds"] = [];
            for (let item of this.bounds)
                data["bounds"].push(item);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["thumbnail"] = this.thumbnail;
        return data;
    }
}

export interface IPublication {
    gid: string;
    publisherGid: string;
    permId?: string | undefined;
    name?: string | undefined;
    slug?: string | undefined;
    sku: string;
    publisherName?: string | undefined;
    typeid: number;
    typeLabel?: string | undefined;
    subtypeLabel?: string | undefined;
    description?: string | undefined;
    covcountry?: string | undefined;
    scaleValue?: number;
    scaleName?: string | undefined;
    itemCount: number;
    years?: IIntervalOfUInt16 | undefined;
    bounds?: number[] | undefined;
    languages?: string[] | undefined;
    thumbnail?: string | undefined;
}

export class IntervalOfUInt16 implements IIntervalOfUInt16 {
    min?: number | undefined;
    max?: number | undefined;

    constructor(data?: IIntervalOfUInt16) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): IntervalOfUInt16 {
        data = typeof data === 'object' ? data : {};
        let result = new IntervalOfUInt16();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}

export interface IIntervalOfUInt16 {
    min?: number | undefined;
    max?: number | undefined;
}

export class TileJSONManifest implements ITileJSONManifest {
    name?: string | undefined;
    description?: string | undefined;
    version?: string | undefined;
    attribution?: string | undefined;
    minZoom?: number;
    maxZoom?: number;
    tiles?: string[] | undefined;

    constructor(data?: ITileJSONManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.version = _data["version"];
            this.attribution = _data["attribution"];
            this.minZoom = _data["minZoom"];
            this.maxZoom = _data["maxZoom"];
            if (Array.isArray(_data["tiles"])) {
                this.tiles = [] as any;
                for (let item of _data["tiles"])
                    this.tiles!.push(item);
            }
        }
    }

    static fromJS(data: any): TileJSONManifest {
        data = typeof data === 'object' ? data : {};
        let result = new TileJSONManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["version"] = this.version;
        data["attribution"] = this.attribution;
        data["minZoom"] = this.minZoom;
        data["maxZoom"] = this.maxZoom;
        if (Array.isArray(this.tiles)) {
            data["tiles"] = [];
            for (let item of this.tiles)
                data["tiles"].push(item);
        }
        return data;
    }
}

export interface ITileJSONManifest {
    name?: string | undefined;
    description?: string | undefined;
    version?: string | undefined;
    attribution?: string | undefined;
    minZoom?: number;
    maxZoom?: number;
    tiles?: string[] | undefined;
}

export class Publisher implements IPublisher {
    gid!: string;
    permId?: string | undefined;
    name?: string | undefined;
    fullname?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;

    constructor(data?: IPublisher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.permId = _data["permId"];
            this.name = _data["name"];
            this.fullname = _data["fullname"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): Publisher {
        data = typeof data === 'object' ? data : {};
        let result = new Publisher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["permId"] = this.permId;
        data["name"] = this.name;
        data["fullname"] = this.fullname;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }
}

export interface IPublisher {
    gid: string;
    permId?: string | undefined;
    name?: string | undefined;
    fullname?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
}

export class PublicationType implements IPublicationType {
    id?: number;
    typeLabel?: string | undefined;
    subtypeLabel?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPublicationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeLabel = _data["typeLabel"];
            this.subtypeLabel = _data["subtypeLabel"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PublicationType {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeLabel"] = this.typeLabel;
        data["subtypeLabel"] = this.subtypeLabel;
        data["description"] = this.description;
        return data;
    }
}

export interface IPublicationType {
    id?: number;
    typeLabel?: string | undefined;
    subtypeLabel?: string | undefined;
    description?: string | undefined;
}

export class MatchCounts implements IMatchCounts {
    publications!: number;
    products!: number;

    constructor(data?: IMatchCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publications = _data["publications"];
            this.products = _data["products"];
        }
    }

    static fromJS(data: any): MatchCounts {
        data = typeof data === 'object' ? data : {};
        let result = new MatchCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publications"] = this.publications;
        data["products"] = this.products;
        return data;
    }
}

export interface IMatchCounts {
    publications: number;
    products: number;
}

export class Filters implements IFilters {
    types?: number[] | undefined;
    publisher?: string | undefined;
    inverseScale?: IntervalOfUInt64 | undefined;
    year?: IntervalOfUInt16 | undefined;
    countryCodes?: string[] | undefined;
    language?: string | undefined;
    availability?: number | undefined;
    /** Simple coordinate ring circumscribing an area of interest.

If a single coordinate is given,
it is interpreted as a box collapsed down to a single point

If only two coordinates are provided in the Boundary,
the coordinates will be interpreted as describing a box.

Otherwise, if the last coordinate does not repeat the first,
that is, if the ring is not closed, we will close it before using it.
The projection is always assumed to be in EPSG:4326 */
    areaOfInterest?: number[][] | undefined;

    constructor(data?: IFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.inverseScale = data.inverseScale && !(<any>data.inverseScale).toJSON ? new IntervalOfUInt64(data.inverseScale) : <IntervalOfUInt64>this.inverseScale;
            this.year = data.year && !(<any>data.year).toJSON ? new IntervalOfUInt16(data.year) : <IntervalOfUInt16>this.year;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.publisher = _data["publisher"];
            this.inverseScale = _data["inverseScale"] ? IntervalOfUInt64.fromJS(_data["inverseScale"]) : <any>undefined;
            this.year = _data["year"] ? IntervalOfUInt16.fromJS(_data["year"]) : <any>undefined;
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
            this.language = _data["language"];
            this.availability = _data["availability"];
            if (Array.isArray(_data["areaOfInterest"])) {
                this.areaOfInterest = [] as any;
                for (let item of _data["areaOfInterest"])
                    this.areaOfInterest!.push(item);
            }
        }
    }

    static fromJS(data: any): Filters {
        data = typeof data === 'object' ? data : {};
        let result = new Filters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["publisher"] = this.publisher;
        data["inverseScale"] = this.inverseScale ? this.inverseScale.toJSON() : <any>undefined;
        data["year"] = this.year ? this.year.toJSON() : <any>undefined;
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        data["language"] = this.language;
        data["availability"] = this.availability;
        if (Array.isArray(this.areaOfInterest)) {
            data["areaOfInterest"] = [];
            for (let item of this.areaOfInterest)
                data["areaOfInterest"].push(item);
        }
        return data;
    }
}

export interface IFilters {
    types?: number[] | undefined;
    publisher?: string | undefined;
    inverseScale?: IIntervalOfUInt64 | undefined;
    year?: IIntervalOfUInt16 | undefined;
    countryCodes?: string[] | undefined;
    language?: string | undefined;
    availability?: number | undefined;
    /** Simple coordinate ring circumscribing an area of interest.

If a single coordinate is given,
it is interpreted as a box collapsed down to a single point

If only two coordinates are provided in the Boundary,
the coordinates will be interpreted as describing a box.

Otherwise, if the last coordinate does not repeat the first,
that is, if the ring is not closed, we will close it before using it.
The projection is always assumed to be in EPSG:4326 */
    areaOfInterest?: number[][] | undefined;
}

export class IntervalOfUInt64 implements IIntervalOfUInt64 {
    min?: number | undefined;
    max?: number | undefined;

    constructor(data?: IIntervalOfUInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): IntervalOfUInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new IntervalOfUInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}

export interface IIntervalOfUInt64 {
    min?: number | undefined;
    max?: number | undefined;
}

export class AggregatedMatchOfPublication implements IAggregatedMatchOfPublication {
    aggregate!: Publication;
    matches!: number;

    constructor(data?: IAggregatedMatchOfPublication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.aggregate = data.aggregate && !(<any>data.aggregate).toJSON ? new Publication(data.aggregate) : <Publication>this.aggregate;
        }
        if (!data) {
            this.aggregate = new Publication();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregate = _data["aggregate"] ? Publication.fromJS(_data["aggregate"]) : new Publication();
            this.matches = _data["matches"];
        }
    }

    static fromJS(data: any): AggregatedMatchOfPublication {
        data = typeof data === 'object' ? data : {};
        let result = new AggregatedMatchOfPublication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregate"] = this.aggregate ? this.aggregate.toJSON() : <any>undefined;
        data["matches"] = this.matches;
        return data;
    }
}

export interface IAggregatedMatchOfPublication {
    aggregate: IPublication;
    matches: number;
}

export class PublicationMatch extends AggregatedMatchOfPublication implements IPublicationMatch {

    constructor(data?: IPublicationMatch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PublicationMatch {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPublicationMatch extends IAggregatedMatchOfPublication {
}

export class PublicationSubFilters extends Filters implements IPublicationSubFilters {
    mapIndex?: string | undefined;
    name?: string | undefined;
    publishedDate?: number | undefined;

    constructor(data?: IPublicationSubFilters) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mapIndex = _data["mapIndex"];
            this.name = _data["name"];
            this.publishedDate = _data["publishedDate"];
        }
    }

    static fromJS(data: any): PublicationSubFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationSubFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapIndex"] = this.mapIndex;
        data["name"] = this.name;
        data["publishedDate"] = this.publishedDate;
        super.toJSON(data);
        return data;
    }
}

export interface IPublicationSubFilters extends IFilters {
    mapIndex?: string | undefined;
    name?: string | undefined;
    publishedDate?: number | undefined;
}

export class ScoredSearchResultOfPublication implements IScoredSearchResultOfPublication {
    result!: Publication;
    score!: number;

    constructor(data?: IScoredSearchResultOfPublication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new Publication(data.result) : <Publication>this.result;
        }
        if (!data) {
            this.result = new Publication();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? Publication.fromJS(_data["result"]) : new Publication();
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): ScoredSearchResultOfPublication {
        data = typeof data === 'object' ? data : {};
        let result = new ScoredSearchResultOfPublication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["score"] = this.score;
        return data;
    }
}

export interface IScoredSearchResultOfPublication {
    result: IPublication;
    score: number;
}

export class Location implements ILocation {
    key!: string;
    formatted?: string | undefined;
    components?: AddressComponent | undefined;
    marker!: number[];
    bounds!: number[];

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.components = data.components && !(<any>data.components).toJSON ? new AddressComponent(data.components) : <AddressComponent>this.components;
        }
        if (!data) {
            this.marker = [];
            this.bounds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.formatted = _data["formatted"];
            this.components = _data["components"] ? AddressComponent.fromJS(_data["components"]) : <any>undefined;
            if (Array.isArray(_data["marker"])) {
                this.marker = [] as any;
                for (let item of _data["marker"])
                    this.marker!.push(item);
            }
            if (Array.isArray(_data["bounds"])) {
                this.bounds = [] as any;
                for (let item of _data["bounds"])
                    this.bounds!.push(item);
            }
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["formatted"] = this.formatted;
        data["components"] = this.components ? this.components.toJSON() : <any>undefined;
        if (Array.isArray(this.marker)) {
            data["marker"] = [];
            for (let item of this.marker)
                data["marker"].push(item);
        }
        if (Array.isArray(this.bounds)) {
            data["bounds"] = [];
            for (let item of this.bounds)
                data["bounds"].push(item);
        }
        return data;
    }
}

export interface ILocation {
    key: string;
    formatted?: string | undefined;
    components?: IAddressComponent | undefined;
    marker: number[];
    bounds: number[];
}

export class AddressComponent implements IAddressComponent {
    _type?: string | undefined;
    country?: string | undefined;
    stateDistrict?: string | undefined;
    countryCode?: string | undefined;
    state?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    busStop?: string | undefined;
    county?: string | undefined;
    road?: string | undefined;
    postcode?: string | undefined;

    constructor(data?: IAddressComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._type = _data["_type"];
            this.country = _data["country"];
            this.stateDistrict = _data["stateDistrict"];
            this.countryCode = _data["countryCode"];
            this.state = _data["state"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.busStop = _data["busStop"];
            this.county = _data["county"];
            this.road = _data["road"];
            this.postcode = _data["postcode"];
        }
    }

    static fromJS(data: any): AddressComponent {
        data = typeof data === 'object' ? data : {};
        let result = new AddressComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_type"] = this._type;
        data["country"] = this.country;
        data["stateDistrict"] = this.stateDistrict;
        data["countryCode"] = this.countryCode;
        data["state"] = this.state;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["busStop"] = this.busStop;
        data["county"] = this.county;
        data["road"] = this.road;
        data["postcode"] = this.postcode;
        return data;
    }
}

export interface IAddressComponent {
    _type?: string | undefined;
    country?: string | undefined;
    stateDistrict?: string | undefined;
    countryCode?: string | undefined;
    state?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    busStop?: string | undefined;
    county?: string | undefined;
    road?: string | undefined;
    postcode?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}